class StickyHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector("header");
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector("predictive-search");

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => {
      this.preventReveal = true;
    };

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    const observer = new IntersectionObserver((entries, obsrvr) => {
      this.headerBounds = entries[0].intersectionRect;
      obsrvr.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollThreshold = 36; // Smaller threshold to trigger sticky header sooner

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    // Scrolling down - trigger after small scroll
    if (scrollTop > this.currentScrollTop && scrollTop > scrollThreshold) {
      requestAnimationFrame(this.reveal.bind(this));
    } 
    // At top of page
    else if (scrollTop <= this.headerBounds.top) {
      if (!this.header.matches(':hover')) {
        requestAnimationFrame(this.reset.bind(this));
      }
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    this.header.classList.add("header--is-hidden");
    this.header.classList.remove("header--is-sticky", "animate");
    this.header.classList.remove("header--is-sticky");
    this.closeSearchModal.bind(this);
  }

  reveal() {
    this.header.classList.add("header--is-sticky");
    this.header.classList.remove("header--is-hidden");
  }

  reset() {
    this.header.classList.remove(
      "header--is-hidden",
      "header--is-sticky",
    );
  }

  closeSearchModal() {
    this.searchModal =
      this.searchModal || this.header.querySelector("details-modal");
    this.searchModal.close();
  }
}

customElements.define("sticky-header", StickyHeader);


document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header");
  const headerOffset = document.querySelector(".header__offset");
  const announcementBarHeight = document.querySelector('#shopify-section-topbar')?.offsetHeight || 0; // Match the threshold from onScroll
  const headerHeight = header.offsetHeight;
  const scrollThreshold = 36; // Smaller threshold to trigger sticky header sooner
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  let hasScrolled = false;

  const headerLogo = document.querySelector("header .header__logo-link");
  const navigationItems = document.querySelectorAll("header .navigation__menu-item");

  // Add not-scrolled class initially
  // header.classList.add("not-scrolled");
  header.classList.add("animate");

  // Listen for scroll to remove not-scrolled class
  window.addEventListener("scroll", () => {
    if (!hasScrolled && window.scrollY > scrollThreshold) {
      hasScrolled = true;
      header.classList.remove("not-scrolled");
    } else if (window.scrollY <= scrollThreshold) {
      hasScrolled = false;
      if (!header.matches(':hover')) {
        header.classList.add("not-scrolled");
      }
    }
    headerOffset.style.height = "0px";
    header.style.top = "0px"; // Reset header position on scroll
  });

  header.addEventListener("mouseenter", () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    header.classList.remove("header--transparent");
    header.classList.add("header--is-sticky");
    header.style.top = scrollTop > announcementBarHeight ? "0px" : `${announcementBarHeight - scrollTop}px`; // Ensure header is at the top
    if (document.body.classList.contains("page-template--index") && windowWidth >= 1024 && !window.transparentHeader) {
      headerOffset.style.height = `${headerHeight}px`; // Set offset height to match header
    }
  });

  headerLogo.addEventListener("mouseenter", () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    header.classList.remove("header--transparent");
    header.classList.add("header--is-sticky");
    header.style.top = scrollTop > announcementBarHeight ? "0px" : `${announcementBarHeight - scrollTop}px`; // Ensure header is at the top
    if (document.body.classList.contains("page-template--index") && windowWidth >= 1024 && !window.transparentHeader) {
      headerOffset.style.height = `${headerHeight}px`; // Set offset height to match header
    }
  });

  navigationItems.forEach((item) => {
    item.addEventListener("mousemove", () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      header.classList.remove("header--transparent");
      header.classList.add("header--is-sticky");
      header.style.top = scrollTop > announcementBarHeight ? "0px" : `${announcementBarHeight - scrollTop}px`; // Ensure header is at the top
      if (document.body.classList.contains("page-template--index") && windowWidth >= 1024 && !window.transparentHeader) {
        headerOffset.style.height = `${headerHeight}px`; // Set offset height to match header
      }
    });
  });

  header.addEventListener("mouseleave", () => {
    if (!hasScrolled) {
      header.style.top = "0px";
      headerOffset.style.height = "0px";

      header.classList.add("header--transparent");
      header.classList.remove("header--is-sticky");
    }
  });

  // predictive-search-icon-trigger click event
  header.querySelector(".predictive-search-icon-trigger").addEventListener("click", () => {
    document.querySelector(".header__cell--bottom .predictive-search__icon-wrapper").click();
    document.querySelector(".header__cell--bottom .predictive-search__input").focus();

    header.classList.add("header--is-sticky");
  });

});